<template>
  <v-row>
    <v-col cols="12" md="10" lg="8" xl="6">
      <v-card flat>
        <div class="v-card-h1 mb-5">Aktywna karta</div>

        <div class="mt-1 d-flex align-center">
          <div class="v-card-h3">Właściciel:</div>

          <div class="v-card-h2 ml-2">{{ profile.firstName }} {{ profile.lastName }}</div>
        </div>

        <div class="mt-1 d-flex align-center">
          <div class="v-card-h3">Numer karty:</div>

          <div class="v-card-h2 mt-1 ml-2">{{ card.number }}</div>
        </div>

        <div class="mt-1 d-flex align-center">
          <div class="v-card-h3">Ważna do:</div>

          <div class="v-card-h2 mt-1 ml-2">{{ expirationDate }}</div>
        </div>

        <v-btn large elevation="0" class="mt-6" @click="openModal('confirmBlock')">Zablokuj kartę</v-btn>
      </v-card>

      <material-dialog
        title="Czy na pewno chcesz zablokować kartę?"
        :show="modals.confirmBlock"
        :close-on-confirm="true"
        @close="closeModal('confirmBlock')"
        @confirm="block"
      />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex';
import { dateFilter } from '@witkac/kartamiejska-shared';
import { schemaMixin } from '@witkac/vuetify-components';

import MaterialDialog from '@/components/material/Dialog';
import { cardMixin } from '@/mixins/cardMixin';
import { displayModalMixin } from '@/mixins/displayModal';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/blockCardSchema';

// @vuese
// Edycja danych profilowych
// @group Profile
export default {
  filters: { dateFilter },
  components: { MaterialDialog },
  mixins: [cardMixin, displayModalMixin, notificationsMixin, schemaMixin],
  schema,
  data() {
    return {
      model: {}
    };
  },
  computed: mapState({ profile: state => state.profile.data }),

  methods: {
    // @vuese
    // Blokuje kartę
    block() {
      this.$store
        .dispatch('card/deactivate', { id: this.card.id })
        .then(() => this.$store.dispatch('card/list'))
        .then(() => {
          this.notifySuccess('Zablokowano kartę.');
          this.closeModal('confirmBlock');
        })
        .catch(() => this.notifyError('Nie udało się zablokować karty.'));
    }
  }
};
</script>
